import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, filter, of, switchMap, tap, withLatestFrom } from 'rxjs';
import { ReferenceService } from '../../../../generated/auth/services/reference.service';
import { loadCountryList, loadListFailure, loadListSuccess, toggleLoadingStatus } from './store.actions';
import { selectCountryIsLoading, selectCountryList } from './store.selectors';

@Injectable()
export class UIEffect {
  private readonly action = inject(Actions);
  private readonly service = inject(ReferenceService);
  private readonly store = inject(Store);

  constructor() {}

  loadList = createEffect(() =>
    this.action.pipe(
      ofType(loadCountryList),
      withLatestFrom(this.store.select(selectCountryList), this.store.select(selectCountryIsLoading)),
      filter(([action, state, status]) => !state?.length && !status),
      tap(() => this.store.dispatch(toggleLoadingStatus({ status: true }))),
      switchMap((action) =>
        this.service.referenceLookupGetCountriesGet().pipe(
          switchMap((response) => {
            const list = (response?.result ?? []).slice();
            const collator = new Intl.Collator('en', { sensitivity: 'base' });
            list.sort((a: any, b: any) => {
              const aName = (a?.name ?? '').trim();
              const bName = (b?.name ?? '').trim();
              const aZA = aName.toLowerCase() === 'south africa';
              const bZA = bName.toLowerCase() === 'south africa';
              if (aZA && !bZA) return -1;
              if (bZA && !aZA) return 1;
              return collator.compare(aName, bName);
            });
            return of(loadListSuccess({ payload: list }));
          }),
          catchError((error) => of(loadListFailure({ error }))),
        ),
      ),
    ),
  );
}
